module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('h1', {
    staticClass: "sigil_not_in_toc"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  })]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page1",
      "title": "1"
    }
  }), _vm._v("1")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "_idParaDest-3",
      "title": "1 Introducing Postmodernism"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v("Introducing Postmodernism")]), _vm._v(" "), _c('p', {
    staticClass: "dingbat"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/Dart_Dingbat.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Our society is in the throes of a cultural shift of immense proportions.")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_vm._v("Stanley J. Grenz,  "), _c('i', [_vm._v("A Primer on Postmodernism")])]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_1"
    }
  }, [_vm._v("Seismic Changes")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Many older Americans have fond memories of the 1950s into the 1960s. The Korean War had ended, the economy and suburbia were booming, we were not at war, television was on the scene, and much in American life seemed good and decent. Unfortunately, this happy time was not to last. The 1960s saw the assassination of President Kennedy, race riots in numerous cities, the Vietnam War and the protests against it, the civil rights movement, the assassinations of Dr. Martin Luther King Jr. and Robert Kennedy, a brutal Democratic Convention in 1968, and an unraveling of the tightly woven fabric of American peace and prosperity. The American landscape had drastically changed between 1960 and 1970, in part for the better and in part for the worse.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("But the Western world and the United States changed in other important ways in the ’60s. The traditional and dominant ways of approaching history, philosophy, theology, and other disciplines came under a sustained assault. The traditional ways involved a worldview commonly known as the Enlightenment."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-037-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" The Enlightenment (and its corresponding worldview, modernism) "), _c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor034"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor035"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor036"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor037"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor038"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor039"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor040"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor041"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor042"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page2",
      "title": "2"
    }
  }), _vm._v("dominated Europe from around 1660 until the start of the French Revolution in 1789. It introduced a number of ideas that challenged traditional Christian ideas, and contributed significantly to the rise of modern science. Christian thinkers were increasingly challenged to defend the faith against a growing secular revolution.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Given that the Enlightenment worldview was often known as modernism, many thought an appropriate label for the new view was postmodernism, based on the simple ideas that it both came after modernism and that it seemed to reject key modernist beliefs. Postmodernism, whatever exactly it was, caught on in literary circles, philosophy, theology, history, and the social sciences. Through the work of the philosopher Thomas Kuhn, it was also seen as attacking the central ideas of science and its claims to certain knowledge and truth. Depending on who and what you read, after the smoke had cleared it didn’t seem like much was left standing. These radical changes in culture and the world of ideas happened simultaneously in both North America and much of Europe, with the year 1968 as the pivotal turning point in the final transition from modern to postmodern.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Throughout the 1950s the Western world was still dominated by Enlightenment modernism. By the end of the 1960s this was no longer the case. In this book we will attempt both to give an overview of modernism and then to seek to define postmodernism in a manner that does justice to its breadth and variety. We intend to aid the reader in understanding postmodernism, and we hope to thoroughly and fairly evaluate postmodernism from a Christian perspective.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We will limit how much we write about leading postmodern thinkers such as Friedrich Nietzsche, Michel Foucault, Jacques Derrida, Jean-François "), _c('a', {
    attrs: {
      "id": "_idTextAnchor043"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor044"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor045"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor046"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor047"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor048"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor049"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor050"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor051"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor052"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor053"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor054"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor055"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor056"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor057"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor058"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor059"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor060"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor061"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor062"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor063"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor064"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page3",
      "title": "3"
    }
  }), _vm._v("Lyotard, and Richard Rorty. We do this not because they are not worth studying, but because they are difficult to write about in a manner that is both clear and accessible to those without a substantial amount of background knowledge. Rather, we will focus on the major themes of post­modernism and weave in some of these thinkers along the way. We believe this topical approach makes the understanding of postmodernism an easier task than an approach that focuses on leading postmodern thinkers. Postmodernism has challenged how evangelical Christians think about the gospel,"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-036-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" about the Scriptures as the inspired Word of God, about knowledge, and about truth itself. If the leading postmodern theologians are correct, then traditional Christianity needs to be overhauled in some significant ways."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-035-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" This overhaul would involve more than mere cosmetic surgery, but rather a radical reorientation and revisioning of the whole of Christian theology and Christian life. In "), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=1+Peter+3%3A15&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("1 Peter 3:15")]), _vm._v(", Peter writes that we should “always be prepared to give an answer to everyone who asks you to give the reason for the hope that you have. But do this with gentleness and respect.” And Paul writes in "), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=2+Corinthians+10%3A5&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("2 Corinthians 10:5")]), _vm._v(" that “we demolish arguments and every pretension that sets itself up against the knowledge of God, and we take captive every thought to make it obedient to Christ.” So both Peter and Paul call on us as Christians to use our minds well in the defense of the faith and in our examination of various philosophies and theologies.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_2"
    }
  }, [_vm._v("Defining Postmodernism")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Before we are in a decent position to present and evaluate post­modernism, we first need to know what it is. One cannot think clearly about a belief or worldview that cannot first be defined. But a number of definitions have been suggested,"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-034-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" and there are even some thinkers who aren’t sure it  "), _c('i', [_vm._v("can ")]), _vm._v("be carefully defined."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-033-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" It should also be noted that a number of books and articles on postmodernism never get around to giving a "), _c('a', {
    attrs: {
      "id": "_idTextAnchor065"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor066"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor067"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor068"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor069"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page4",
      "title": "4"
    }
  }), _vm._v("­definition of it, perhaps because they think it is obvious or because they themselves are not sure exactly what it is. In this book we will understand postmodernism both as a worldview (which includes a number of beliefs about the nature of knowledge and reality) and as the worldview that follows Enlightenment modernism. In the first sense, postmodernism can be understood philosophically, while in the latter sense it is better understood historically—as a particular worldview that follows in time another particular worldview.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Before we attempt an initial definition, one more matter needs to be discussed. This involves what has often been called the principle of charity. The basic idea here is that when we read and seek to understand a differing view, we should always give the benefit of the doubt (act charitably) toward the view and its author. If there are two ways to read a particular page or passage, and one of them makes the author look like an idiot while the other one does not, the kind or charitable thing to do is to understand them in the second sense. In an important sense this is simply applying the basic message of "), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=1+Corinthians+13&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("1 Corinthians 13")]), _vm._v(" to our fellow humans. It is kind and charitable to give someone the benefit of the doubt, and unkind not to do so. In what follows we will make every effort to read and understand with this principle in mind. A simple example is as follows: a few years back, Larry King of CNN fame made the following comment about some people filling sandbags to aid in flood control: “It’s wonderful that we have eight-year-old boys filling sandbags with old women.” We suspect that what he meant to say was something like the following: “It’s wonderful that we have eight-year-old boys and old women filling sandbags together.” Given the principle of charity, "), _c('i'), _vm._v("we understand King to mean that people were working together rather than that boys were stuffing sandbags with the elderly. Similarly, advocates of postmodernism will be understood as trying to make sensible (rather than ridiculous) claims, unless we have good evidence to the contrary.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Now we are in a position to offer an initial definition of postmodernism. We believe that postmodernism is committed to all of the following beliefs:"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-032-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "TOC_chpt_no"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor070"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor071"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor072"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor073"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor074"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor075"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor076"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor077"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor078"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor079"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor080"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor081"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor082"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor083"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor084"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor085"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor086"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor087"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor088"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor089"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor090"
    }
  })])]), _c('span', {
    staticClass: "TOC_chpt_no"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page5",
      "title": "5"
    }
  })]), _c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Postmodernism challenges the Enlightenment confidence in human reason.")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("This tenet involves rejection of the key beliefs of Enlightenment modernism, especially the confidence in human reason and René Descartes’s conviction that we could achieve certain knowledge by following his method. Descartes’s thought is still admired by many, though we believe he set his sights too high, demanding a level of certainty only rarely attained by humans.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Postmoderns believe the human person is heavily situated rather than a neutral observer.")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Postmoderns place heavy emphasis on the fact that our beliefs, values, and worldviews are all significantly, if not entirely, shaped by our situation in life. The big word for this is  "), _c('i', [_vm._v("situatedness")]), _vm._v("—the idea that we humans cannot look at the world/reality with complete objectivity, but only from a particular point of view that shows the massive influence of culture and the environment we grew up in.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("3")]), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Postmoderns reject the idea that language simply and transparently captures the world around us.")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Modernism had a good deal of confidence in the ability of language to capture or mirror the external realities to which it referred. So the claim “The cat is on the mat” captures the ideas that there is a cat (external to our minds), a mat, and that the cat has a particular relation to the mat (she is on it). Such an understanding views language as stable and unchanging over time. Many postmodern thinkers reject the idea that language accurately represents external realities and the idea that language is stable over time. If the modernist view of language is mistaken, it undermines some of the main tenets of the Enlightenment.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("4")]), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Postmodern thinkers view truth as something that is created/constructed by human beings, rather than something discovered that is (in some sense) already out there.")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Descartes, John Locke, and many other later philosophers viewed truth as something that exists prior to humans’ thinking about it. So, for example, the claim “dinosaurs existed” was thought to be true even if no human ever thought about it. This is because dinosaurs existed well before humans ever came on the scene. But suppose this understanding of truth is mistaken? Suppose truth is created (or “constructed”) rather than discovered. Many "), _c('a', {
    attrs: {
      "id": "_idTextAnchor091"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor092"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor093"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor094"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor095"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor096"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor097"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor098"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor099"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor100"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor101"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor102"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor103"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor104"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor105"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor106"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor107"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor108"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor109"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor110"
    }
  }), _vm._v("postmoderns claim that we humans build or construct truth, rather than "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page6",
      "title": "6"
    }
  }), _vm._v("discover some truth which already existed. This is a complicated matter, one we will develop in more detail later in the book.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("5")]), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Postmodern thinkers reject the idea that the human self is stable and continuous over time.")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Descartes and his fellow moderns"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-031-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" believed that the human self endured over time, was relatively unchanging, and had a relatively fixed human nature. Postmoderns, following Friedrich Nietzsche and David Hume, think the idea of an enduring self is a fiction. They see the self as ever changing, as constructed by both our choices and the constant environmental influences around us, and they reject the idea of the self as conceived of both by many moderns and by traditional Christianity.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("6")]), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Postmoderns have gnawing doubts as to whether the methods used by historians and those in the social sciences provide any hope of arriving at objective truth.")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("In the 1950s the great majority of historians and social scientists still believed that certain methods carefully followed would lead us to some degree of objective knowledge and to truth. This view is sometimes labeled methodological objectivity. A historian carefully following methodological objectivity would be in an excellent position to know various historical truths. Such truths were better described as discovered than created. Postmoderns, however, see the idea of methodological objectivity as very much worthy of our rejection. The results of such methods, they argue, are primarily reflective of our environment and our subjective choices (the idea of situatedness again), and are thus not scientific or purely reasonable.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("7")]), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Postmoderns challenge the traditional idea that Europe and North America are somehow (morally) superior to countries in Asia, Africa, and so on.")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("One of the central claims of most postmodern thinkers is that human history, rather than being marked by fairness and decency, has instead been characterized by massive oppression. So though the United States is founded on some very impressive documents (the Constitution and the Declaration of Independence), American history has often failed to live up to those ideals. Not everyone has been treated well. For example, African Americans, women, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor111"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor112"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor113"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor114"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor115"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor116"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor117"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor118"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor119"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor120"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor121"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor122"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor123"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor124"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor125"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor126"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor127"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor128"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor129"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor130"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor131"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor132"
    }
  }), _vm._v("Native Americans, Asians, Hispanics, Jews, Catholics, the Irish, laborers, the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page7",
      "title": "7"
    }
  }), _vm._v("poor, and the disabled"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-030-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" have all been the victims of significant oppression over a long period of time. History texts in the past often turned a blind eye to this oppression,"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-029-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" and instead focused on the achievements of an elite few, usually white men. Beginning in the 1960s many historians began to focus on how common, ordinary people lived from day to day, writing rich histories about women, African Americans, the poor, and many others."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-028-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" There was an emphasis on a plurality of voices and a number of perspectives rather than the single (sometimes elitist) voice of the most powerful groups in society.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("8")]), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Postmoderns have come to increasingly see truth as more therapeutic in nature than as static and objective.")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Prior to the 1960s those who doubted the existence of truth were still a distinct minority."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-027-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" The rise of postmodernism has changed all that. Richard Rorty, for example, began his academic career teaching philosophy at Princeton. By the end of his career he had moved away from Princeton and away from traditional ideas of truth to teaching comparative literature. He was convinced that rather than possessing truth, all we humans have left is local stories (what life seems like from some particular point of view) rather than a larger story (sometimes called a metanarrative; see number 9 below) that is true for everyone. Rorty hoped that people would adopt a politically liberal humanism, but he himself admitted that it was no truer than any other view. Rorty and others saw human situatedness (or embeddedness) as making it impossible for any human to be in a position to make claims that are genuinely true. So better views are not any “truer” than any other view, but they could better help us cope with the difficulties of life. On this view coping takes the place of truth, and better views are seen as  "), _c('i', [_vm._v("therapeutic")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "TOC_chpt_no"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor133"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor134"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor135"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor136"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor137"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor138"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor139"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor140"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor141"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor142"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor143"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor144"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor145"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor146"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor147"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor148"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor149"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor150"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor151"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor152"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor153"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor154"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor155"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor156"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor157"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor158"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor159"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor160"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor161"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor162"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor163"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor164"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor165"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor166"
    }
  })])]), _c('span', {
    staticClass: "TOC_chpt_no"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page8",
      "title": "8"
    }
  })]), _c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("9")]), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Postmoderns see metanarratives as inherently oppressive and as generally beyond the ability of humans to grasp them.")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Lyotard is perhaps best known for defining postmodernism as “incredulity towards metanarratives.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-026-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" A metanarrative is an overarching story or worldview, a story that claims to describe the main elements of reality in one big story. Possible examples of metanarratives include Marxism, Enlightenment humanism (or modernism), scientism,"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-025-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" Christianity, and Buddhism. Some have understood Lyotard’s claim to rule out Christianity, while others"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-024-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" have claimed that Lyotard did not have Christianity in mind when he made this claim.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("10")]), _c('span', {
    staticClass: "b-i"
  }, [_vm._v("Postmoderns reject what has been called the omnicompetence of reason.")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Enlightenment thinkers clearly display a significant confidence in human reason and its ability to know truth, to know it with certainty, and to use those truths to bring about the steady improvement of the human race. Thus reason properly applied leads to the progress of civilization. Alister McGrath has referred to this confidence as a belief in the omnicompetence of human reason."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-023-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" Descartes, Locke, Gottfried Wilhelm Leibniz, Thomas Reid, the French philosophes, and Kant all possess large measures of this faith in reason."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-022-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" Postmodern thinkers, on the other hand, challenge and/or reject this confidence as unwarranted. Thinkers from Nietzsche to Foucault to Derrida led the assault against this confidence. They saw reason as far more limited, certainty as an illusion, and the idea of human progress as being shattered by the devastation of World War I, the death camps and the Holocaust, and the mass slaughter of millions in the most violent century in human history."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-021-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" Many late nineteenth-century thinkers had high hopes for the twentieth century, where the lion would lie down with the lamb and war would be but a distant memory. Well, the lion did lie with the lamb and "), _c('a', {
    attrs: {
      "id": "_idTextAnchor167"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor168"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor169"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor170"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor171"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor172"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor173"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor174"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor175"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor176"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor177"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor178"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor179"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor180"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor181"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor182"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor183"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor184"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor185"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor186"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor187"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor188"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page9",
      "title": "9"
    }
  }), _vm._v("then ate it, putting to rout the idea of an extended period of peace and prosperity in the twentieth century.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The previous pages make it apparent that postmodernism is a complicated and diverse movement, one that challenges evangelical Christians to carefully rethink their beliefs and traditions. Evangelical Christianity traditionally has been committed to the objectivity of truth, the stability of language, and the idea that the Christian metanarrative is far from oppressive, as well as to a degree of trust in the deliverances of human reason. In this book we seek to carefully understand and respond to the various challenges presented by postmodernism, and to determine whether some Christian beliefs need to be modified or rejected in light of these challenges.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_3"
    }
  }, [_vm._v("Concerning Point of View")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("For many years philosophers, theologians, and historians all believed that their particular disciplines could be approached with a cool and dis­passionate neutrality. In other words, through sufficient effort we could be fair and impartial observers and arrive in the end with a firm grasp of ­objective truths. This idea of the neutral observer arises out of the Enlightenment, the rise of science, and a supreme confidence in the human ability to reason. Some central Enlightenment thinkers thought we humans could relate to reality much as an ideal modern-day baseball umpire interacts with baseball. The umpire knows the rules, he plays no favorites, and he fairly and even-handedly applies the rules to both teams, never showing any hint of favoritism or undue bias."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-020-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" The umpire is thus a sort of scientific observer of all that goes on around him. In theology, some theologians believed that theology itself could be grounded on wholly scientific principles, and that the careful theologian maintained a strict adherence to the proper principles of biblical criticism. And in twentieth-century Western philosophy, a movement known as logical positivism attempted to turn philosophy into a scientific discipline that ruthlessly applied a strict set of rules about what did and did not count as knowledge. Unfortunately, neither liberal theologians nor the positivists succeeded in their efforts to make their discipline truly scientific. The theologically liberal approach is clearly biased against belief "), _c('a', {
    attrs: {
      "id": "_idTextAnchor189"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor190"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor191"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor192"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor193"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor194"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor195"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor196"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor197"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor198"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor199"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor200"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor201"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor202"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor203"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor204"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor205"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor206"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor207"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page10",
      "title": "10"
    }
  }), _vm._v("in miracles, a bias that no decent evangelical scholar can agree with."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-019-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" And positivism, after a brief and glorious fling at the top of the charts (in philosophical circles), died a painful and (some would say) richly deserved death around 1960."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-018-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" American historians, though also priding themselves on their scientific approach to history, fared no better than their counterparts in theology or philosophy. The historian Peter Novick eloquently describes the rise and fall of such an approach in his book  "), _c('i', [_vm._v("That Noble Dream")]), _vm._v("."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-017-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("It is now widely acknowledged by Christian and non-Christian scholars alike that such neutrality is not humanly possible. N. T. Wright,"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-016-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" Jay Wood,"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-015-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" Alan Padgett,"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-014-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" and a number of other fine evangelical scholars readily admit this. Does this mean that we are all caught in a web of our own biases, prejudices, and cultural influences? The answer is no, though it requires both training and discipline to minimize the influence of such factors, though some degree of influence will always be present. As scholars we should identify our assumptions and biases, put them on the table so to speak, and write and think from a point of view that acknowledges all these influences. That is what we intend to do in this book.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_4"
    }
  }, [_vm._v("Our Working Assumptions")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("So what sorts of assumptions do we have? In what follows we list both our core beliefs and a few facts about ourselves that influence how we look at the world.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("Background influences")]), _vm._v(":")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("We are evangelical Christians.")]), _vm._v(" "), _c('li', [_vm._v("We are Protestants.")]), _vm._v(" "), _c('li', [_vm._v("Our training is in philosophy and theology.")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor208"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor209"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor210"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor211"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor212"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor213"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor214"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor215"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor216"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor217"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor218"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor219"
    }
  })]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page11",
      "title": "11"
    }
  }), _vm._v("We are both trained in what is known as the analytic tradition (as opposed to the continental tradition).")]), _vm._v(" "), _c('li', [_vm._v("Politically, we are in the conservative to moderate range on most issues.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('i', [_vm._v("Core beliefs")]), _vm._v(":")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("We have a modest confidence in human reason.")]), _vm._v(" "), _c('li', [_vm._v("We are committed to the inspiration and inerrancy of Scripture.")]), _vm._v(" "), _c('li', [_vm._v("We are committed to make every effort to treat every view with respect and care.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We offer our conclusions not in the spirit of Descartes (who thought a high level of certainty was possible), but rather as broadly reasonable claims, submitted by fallible and situated knowers. We readily admit we are answerable to the same standards as all other humans: the truths (and Truth) of Scripture, the laws of logic, and the carefully sifted evidence of human experience and human reason. We do not claim that our views are always the only view possible, though we do offer them as what we take to be the best explanation of all things considered.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The list above does not exhaust our various assumptions and biases, though it does give a representative sample. We both also reject the idea that all of our beliefs and values somehow reduce to one or more of the factors that have influenced us. If that were true, then all we would be doing is sharing our own stories with no claim to truth or reasonability. Yes, many factors shape and influence us, but that is a long way from any sort of ideological determinism, where truth claims and claims about rationality merely reduce to our respective social situations. This is an extreme version of the idea of the sociology of knowledge.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_5"
    }
  }, [_vm._v("Overview of the Book")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("In the upcoming pages we cover a lot of ground, make a number of substantive (and controversial) claims, and seek to understand and evaluate the family of views known as postmodernism from a viewpoint grounded in the truths of the Scriptures and the historic Christian faith. We devote a full chapter to each of the ten main strands of postmodernism, and even in this we are being selective and not dealing with many worthwhile issues. To deal with all the relevant issues in significant detail would require a much longer "), _c('a', {
    attrs: {
      "id": "_idTextAnchor220"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor221"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor222"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor223"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor224"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor225"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor226"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor227"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor228"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor229"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor230"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor231"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor232"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor233"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor234"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor235"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor236"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor237"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor238"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor239"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor240"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor241"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor242"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor243"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor244"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor245"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor246"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor247"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor248"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page12",
      "title": "12"
    }
  }), _vm._v("book, one that would please neither our readers nor our editors. So what we offer is an overview of some key themes of postmodernism. Some of the issues we address are, to put it simply, complicated. At times we seek to simplify, but hopefully never to the point of distortion or caricature.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In chapter two we present a framework for understanding postmodernism. The framework helps to make sense of the background of the Enlightenment, the context in which postmodernism arose, and the various historical events that contributed to the decline of Enlightenment modernism. The wild and crazy 1960s and the social unrest that marked this time period clearly ­contributed to the breakdown of the older ways and the rise of new (and not always improved) ways of understanding truth, knowledge, language, and the broader world around us. It is fair to say that the world looked very ­different in 1970 than it did to many academics in the late ’50s and early ’60s. The Vietnam War, the events in Paris in 1968, the rise of antiwar and free speech movements, and a general disillusionment with traditional ­authorities all converged to challenge the old ways and to foster new ways of looking at familiar issues.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In chapter three we offer an overview of the worldview spawned by the Enlightenment, namely, modernism. Modernism challenged the authority of the Scriptures, the role of the church, and a view of the universe in which God was at the center of things. Modernism questions the existence of God, seriously doubts the doctrine of original sin, elevates human reason, sees science as the key to future human progress, and generally doubts the miraculous. Traditional Christianity was also challenged by deism,"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-013-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" Socinianism,"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-012-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" the reduction of Christianity to mere morality,"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-011-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" and good old-fashioned humanism."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-010-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" But as the twentieth century unfolded, the central beliefs of modernism began to crumble one by one, only to be replaced a variety of views that can be conveniently grouped under the heading “postmodern.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor249"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor250"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor251"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor252"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor253"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor254"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor255"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor256"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor257"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor258"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor259"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor260"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor261"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor262"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor263"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor264"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor265"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor266"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor267"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor268"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor269"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor270"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor271"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor272"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor273"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor274"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor275"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor276"
    }
  })]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page13",
      "title": "13"
    }
  }), _vm._v("In chapter four we discuss Enlightenment thinkers, such as Descartes, who were confident of their ability to be neutral, detached, and scientific observers of the world around them. By focusing and reflecting, we could see the world as it truly is, rising above the influence of our social situation. The first professional American historians proudly proclaimed their ability to produce scientific histories."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-009-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" Many prominent theologians likewise proudly proclaimed that their scientific and scholarly approach to the New Testament ruled out belief in the miraculous, including the belief in the bodily resurrection of Jesus. Traditional Christianity, needless to say, did not fare well in the work of such scholars. Some leading historians such as Charles Beard and Carl Becker rejected the idea that a scholar could be neutral and detached, but the idea of scientific neutrality lasted well into the 1980s in theological circles."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-008-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" Postmodern thinkers, following the lead of Beard, Becker, Thomas Kuhn, Nietzsche, and others, readily admitted that there was no neutral starting point. In evangelical circles the New Testament scholar N. T. Wright has made it clear that he does not strive for the neutrality and detachment of his modernist predecessors. We will argue that the recognition of the idea that humans are embedded (or situated) is simply facing up to what has been true all along. More importantly, we argue that recognition of this preexisting point of view does nothing to undermine the reasonableness of traditional Christianity.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Most thinkers before 1900"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-007-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" had confidence that human language had the ability to accurately capture the external reality to which it referred. In this sense language was seen as the mirror (or faithful copy) of nature. Under the influence of Ferdinand de Saussure, Roland Barthes, Jacques Derrida, and others, language was no longer seen as having the ability to mirror reality. It was now seen as an arbitrary and unstable (changing over time) human invention that did not generally refer to anything outside itself. In the United States the assault on the traditional mirroring function of language was carried out by the philosopher Richard Rorty. Though Rorty did "), _c('a', {
    attrs: {
      "id": "_idTextAnchor277"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor278"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor279"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor280"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor281"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor282"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor283"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor284"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor285"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor286"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor287"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor288"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor289"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor290"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor291"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor292"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor293"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor294"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor295"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page14",
      "title": "14"
    }
  }), _vm._v("not doubt the existence of the external world, he did doubt the ability of humans to genuinely know anything about that world. In chapter five, we conclude with a critique of this view of language.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In "), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=John+18%3A38&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("John 18:38")]), _vm._v(", Pilate famously asks, “What is truth?” Such questions have long been at the heart of the philosophical enterprise and also at the center of orthodox Christianity. To commit oneself to the good news of the gospel is to commit oneself to the truth of the message. If Jesus truly died and rose again it is good news indeed, but if he did not we are most of all to be pitied (see "), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=1+Cor+15%3A14-19&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("1 Cor 15:14-19")]), _vm._v("). In chapter six we focus on the nature of truth and whether it is better described as something discovered or something created or constructed. Much hinges on this issue if traditional Christianity is to be taken seriously, and we seek to determine to what extent, if any, truth is merely a human creation. Traditional Christianity has always affirmed that God speaks truthfully in and through the Scriptures, and that these truths transcend (rise above) our various and sundry positions in life. Some evangelicals argue, correctly we think, that to tell the good news of the gospel is to speak objective truth to a lost and dying world."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-006-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" As such, traditional Christianity is a broad and overarching story (a metanarrative) of the human condition and the work of the one true God.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Descartes, who sought to use autonomous human reason"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-005-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" in his efforts to find an absolutely certain starting point for philosophy, is often identified as the first truly modern philosopher. Skepticism, a view that seriously questioned the human ability to acquire genuine knowledge, was the enemy, and Descartes searched high and low for a firm foundation in response to the skeptics. He doubted everything it was possible to doubt, eventually arriving at what he took to be an absolutely certain truth."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-004-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" He discovered that he could not doubt that he was doubting, hence his famous phrase, “I think, therefore I am,” by which, roughly speaking, he means that if I am thinking, then I must exist. This he declared to be indubitably true, that is, incapable of being doubted. Philosophers ever since have wondered what the word  "), _c('i', [_vm._v("I")]), _vm._v(" refers to here. Descartes’s answer would be “the self,” the person or subject "), _c('a', {
    attrs: {
      "id": "_idTextAnchor296"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor297"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor298"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor299"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor300"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor301"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor302"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor303"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor304"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor305"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor306"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor307"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor308"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor309"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor310"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor311"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor312"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor313"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor314"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor315"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor316"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor317"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor318"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page15",
      "title": "15"
    }
  }), _vm._v("who is doing the thinking. Okay, but how does he know that there is a self in the first place, or at least a self that stays the same over time? The short answer is that he doesn’t; he pretty much assumes a particular understanding of the human self (what makes us who we are) over time. The question then arises whether we should think of the self as remaining constant over time—that I am the same person from one day to the next—or whether it is constantly in flux. For example, Hume questions whether Descartes’s view of the human self holds up under scrutiny, and Buddhist thought in general holds a differing conception of the self. Most postmodern thinkers have tended to side with Hume and against Descartes on this matter. Thus in chapter seven we examine various understandings of the self, including postmodern developments.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The 1600s in Europe gave rise to the remarkable rise of modern science, led by eminent scientists such as Francis Bacon and Isaac Newton. Both leading scientists and leading philosophers (such as Descartes and Locke) firmly believed that humans could use objective (or science-like) methods to guarantee the individual genuine knowledge of the world around us. So, the idea goes, if someone seeking knowledge follows the rules of science properly, then they have an excellent chance of acquiring bias-free, objective knowledge. Of course, this method assumes that the observer is  "), _c('i', [_vm._v("ahistorical")]), _vm._v(", meaning they are not trapped within their own cultural situation and influences, but instead are able to rise above the various influences to achieve truly certain knowledge. Postmodern thinkers are not impressed. They seriously question both the idea that the observer is not situated or embedded in their social context,"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-003-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" and that the rules of knowledge seeking are either as obvious or as easy to grasp as was thought in the Enlightenment. In chapter eight we thus investigate the postmodern critique of what we will call methodological objectivity, and we seek to determine how much validity there is in the criticism. We also seek to defend a version of scientific realism against postmoderns who tend to advocate some form of antirealism.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("As noted above, well into the twentieth century many American history texts had relatively little to say about the rather shabby treatment of various minorities in American history. So the idea that African Americans, women, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor319"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor320"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor321"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor322"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor323"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor324"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor325"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor326"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor327"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor328"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor329"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor330"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor331"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor332"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor333"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor334"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor335"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor336"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor337"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor338"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor339"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page16",
      "title": "16"
    }
  }), _vm._v("Latinos, Jews, Native Americans, and others had been systematically mistreated received little attention and less discussion. But the writing of American history began to shift its focus in the 1960s and 1970s, and the growing awareness of social and cultural history gave rise to an increased sensitivity to these difficult aspects of our past."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-002-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" In fact, in postmodern conceptions of history it came to be considered more accurate to write of the oppression of all these groups, and to admit that the previous texts in American history distorted the past by not recognizing the existence and degree of oppression of these groups. In chapter nine we investigate both these claims as well as the more radical idea that all history writing is somehow oppressive.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In chapter ten we focus on Lyotard’s well-known claim “Simplifying to the extreme, I define postmodern as incredulity towards metanarratives.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-001-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" There are a number of important issues here, of which we examine only two or three. The first issue deals with what exactly a metanarrative is, which not surprisingly includes the issue of what a narrative is. A second issue deals with what exactly Lyotard’s claim means. Does he have all worldviews in mind (including Christianity), or does he just have a few specific views in mind that do not include Christianity?")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In chapter eleven we tackle issues surrounding the concept of truth. To say that the idea of truth is a complicated matter is an understatement of colossal proportions."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-000-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/21_notes#footnote-000",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" There are numerous views among philosophers regarding the nature of truth, and we examine a few of the leading contenders. We will argue that one of the many understandings of truth is more reasonable than the others.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Finally, in chapter twelve we take a look at the Enlightenment understanding of human reason and how that understanding influenced the course of subsequent thought. We also examine the postmodern rejection of Enlightenment reason and whether postmodern views of human reason are any closer to the truth than the various Enlightenment views. And "), _c('a', {
    attrs: {
      "id": "_idTextAnchor340"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor341"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor342"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor343"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor344"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor345"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor346"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor347"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page17",
      "title": "17"
    }
  }), _vm._v("though we agree with the postmoderns that the Enlightenment view of reason has significant flaws, we also see postmodern views as not doing justice to the concept of reason properly understood. We defend a view of knowledge known as modest foundationalism.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In chapters thirteen and fourteen we conclude the book by focusing on the central claims of traditional Christianity as embodied in the good news of the gospel and by summarizing what we have done in the book and the many issues that remain to be more fully addressed in the future. Those hoping to find either a sustained critique of all that postmoderns believe or a welcome embrace of all postmodernism suggests will be sorely disappointed. We hope to fairly present and examine postmodernism, to evaluate it in the light of biblical Christianity, and to challenge the reader to carefully and humbly draw their own conclusions about what we present.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "sigil_toc_id_6"
    }
  }, [_vm._v("Suggested Readings")]), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("Copan, Paul.  "), _c('i', [_vm._v("True for You, but Not for Me: Overcoming Objections to Christian Faith")]), _vm._v(". Grand Rapids: Bethany House, 2009. A very readable approach to the idea of truth by a leading evangelical philosopher.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("Grenz, Stanley J.  "), _c('i', [_vm._v("A Primer on Postmodernism")]), _vm._v(". Grand Rapids: Eerdmans, 1996. An introductory book by a leading evangelical who is sympathetic to some major postmodern claims.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("Groothuis, Douglas.  "), _c('i', [_vm._v("Truth Decay: Defending Christianity Against the Challenges of Postmodernism")]), _vm._v(". Downers Grove, IL: InterVarsity Press, 2000. One of the better introductions to postmodernism by an evangelical philosopher.")]), _vm._v(" "), _c('p', {
    staticClass: "biblio"
  }, [_vm._v("White, Heath.  "), _c('i', [_vm._v("Postmodernism 101: A First Course for the Curious Christian")]), _vm._v(". Grand Rapids: Brazos, 2006. A brief and highly readable introduction to postmodernism.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2913d9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/06_ch1.vue
// module id = 69
// module chunks = 0